import { render, staticRenderFns } from "./LogoSmall.vue?vue&type=template&id=064ab026"
import script from "./LogoSmall.vue?vue&type=script&lang=ts"
export * from "./LogoSmall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports